export const LIQUIDITY_PROVIDER_FEE = 0.003 // 0.3%
